import React from "react"
import { FooterWrapper } from "./styled"
import text from "../../data/text.json"

const Attributions = () => (
  <>
    <div>
      <span>
        Icons made by{" "}
        <a
          href="https://www.flaticon.com/authors/smashicons"
          title="Smashicons"
        >
          Smashicons
        </a>{" "}
        from{" "}
        <a href="https://www.flaticon.com/" title="Flaticon">
          www.flaticon.com
        </a>
      </span>
    </div>
    <span>
      Developed by Aron Edwards{" "}
      <a
        href="https://www.aronedwards.co.uk/"
        title="Aron Website"
        rel="noopener noreferrer"
        target="_blank"
      >
        aronedwards.co.uk
      </a>
    </span>
  </>
)

const Footer = () => (
  <FooterWrapper>
    <p>{text.footer.jargon}</p>
    <div>
      <Attributions />
    </div>
  </FooterWrapper>
)

export default Footer
